import queryString from 'querystring'

export function getMVPUrl (window) {
  const host = window.location.hostname
  let domain = host.split('.').slice(-2).join('.')

  if (domain === 'localhost') {
    domain = 'mapmyrun.com'
  }

  return `http://mvp.${domain}`
}

// Base64 encode the context JSON
function generateContextString (originalQueryString, authScreen) {
  const context = {
    originalQueryStringParams: queryString.parse(
      originalQueryString.replace('?', '')),
    authScreen: authScreen,
  }

  return btoa(JSON.stringify(context))
}

export function getWechatOauthUrl (window, apiConfig, authScreen) {
  const wechatQueryString = queryString.stringify({
    appid: apiConfig.appId,
    redirect_uri: `${window.location.origin}/auth/callback/wechat`,
    response_type: 'code',
    scope: 'snsapi_login,snsapi_userinfo',
    state: generateContextString(window.location.search, authScreen),
  })
  return `${apiConfig.clientApiRoot}/connect/qrconnect?${wechatQueryString}`
}

export function getWechatSignupUrl (window, apiConfig) {
  return getWechatOauthUrl(window, apiConfig, 'signup')
}

export function getWechatLoginUrl (window, apiConfig) {
  return getWechatOauthUrl(window, apiConfig, 'login')
}
